export default __webpack_public_path__ + "assets/icons/question.9c349a69.svg";